import { createContext, useContext } from 'react'

export type Branding = 'codecorp' | 'brady'
export const BrandingContext = createContext<Branding>('codecorp')
export const useBranding = () => useContext(BrandingContext)
